module.exports = __webpack_public_path__ + "img/download-btn.5da86002.svg";